import DashboardIcon from '@mui/icons-material/Dashboard';
import ShoppingCartIcon from '@mui/icons-material/ShoppingCart';
import ContactsIcon from '@mui/icons-material/Contacts';
import ManageAccountsIcon from '@mui/icons-material/ManageAccounts';
import BusinessIcon from '@mui/icons-material/Business';
import TwoWheelerIcon from '@mui/icons-material/TwoWheeler';

export const SIDEBAR_WIDTH = 280;
export const SIDEBAR_COLLAPSED_WIDTH = 72;

export const getNavItems = (userRole) => {
  if (userRole === 'rider') {
    return [
      { key: 'deliveries', title: 'Deliveries', href: '/riders-portal', icon: TwoWheelerIcon },
    ];
  }

  const items = [
    { key: 'dashboard', title: 'Overview', href: '/', icon: DashboardIcon },
    { key: 'orders', title: 'Orders', href: '/orders', icon: ShoppingCartIcon },
    { key: 'customers', title: 'Customers', href: '/customers', icon: ContactsIcon },
  ];

  if (userRole === 'cus-admin' || userRole === 'super-admin') {
    items.push({ key: 'users', title: 'Users', href: '/admin/users', icon: ManageAccountsIcon });
  }

  if (userRole === 'super-admin') {
    items.push({ key: 'companies', title: 'Companies', href: '/companies', icon: BusinessIcon });
  }

  return items;
};

export const isNavItemActive = (pathname, href) => {
  if (href === '/') {
    return pathname === '/' || pathname === '/analytics';
  }
  return pathname === href || pathname.startsWith(`${href}/`) || pathname.startsWith(`${href}?`);
};
